/* SPACES: wallpaper strips (58 cm wide, 300 or 400 cm long, strips overlap 10 mm, minimum 2 strips)
   quantity discount by total area of the order: -5 % per started 5 m2, up to -25 % from 25 m2 */
window.__spRolls = {
  LENS: [300, 400],
  MIN: 2,
  TIERS: [0, 5, 10, 15, 20, 25],
  plan: function (w, h) {
    var n = Math.max(1, Math.ceil((w - 1) / 57)), seg = h + 5, len = null, i;
    for (i = 0; i < this.LENS.length; i++) { if (this.LENS[i] >= seg) { len = this.LENS[i]; break; } }
    return { n: n, seg: seg, best: len ? { len: len, qty: Math.max(this.MIN, n) } : null };
  },
  tier: function (q, len) { return Math.min(5, Math.floor(q * 0.58 * len / 100 / 5 + 1e-9)); },
  firstQty: function (len, t) { var q = this.MIN; while (this.tier(q, len) < t) q++; return q; },
  vfor: function (vars, len, t) {
    var k = len + ' cm / ' + this.TIERS[t] + ' %', i;
    for (i = 0; i < vars.length; i++) { if (vars[i].title === k) return vars[i]; }
    return null;
  },
  fmt: function (c) { return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft'; },
  mtier: function (n) { return Math.min(5, Math.floor(n / 5)); },
  mtable: function (rate, n, money, T) {
    var cur = n ? this.mtier(n) : -1, rows = '', t, lab;
    for (t = 0; t < 6; t++) {
      lab = t === 0 ? '1–4 m²' : t === 5 ? '25+ m²' : (5 * t) + '–' + (5 * t + 4) + ' m²';
      rows += '<li' + (t === cur ? ' class="on"' : '') + '><span class="q">' + lab + '</span><span class="p">' + this.fmt(Math.round(rate * (100 - 5 * t) / 100 / 10) * 10) + ' / m²</span><span class="d">' + (t ? '−' + (5 * t) + ' %' : '') + '</span></li>';
    }
    return '<p class="sp-tiers-h">' + (T.tTierm || '') + '</p><ul>' + rows + '</ul><p class="sp-tiers-n">' + (T.tTiermNote || '') + '</p>';
  },
  table: function (vars, len, qty, money, T) {
    var cur = this.tier(qty, len), rows = '', t, from, to, v, lab;
    for (t = 0; t < 6; t++) {
      v = this.vfor(vars, len, t); if (!v) continue;
      from = this.firstQty(len, t); to = t < 5 ? this.firstQty(len, t + 1) - 1 : null;
      lab = to === null ? from + '+' : (from === to ? '' + from : from + '–' + to);
      rows += '<li' + (t === cur ? ' class="on"' : '') + '><span class="q">' + lab + ' ' + (T.tEach || '') + '</span><span class="p">' + this.fmt(v.price) + ' / ' + (T.tEach || '') + '</span><span class="d">' + (t ? '−' + this.TIERS[t] + ' %' : '') + '</span></li>';
    }
    return '<p class="sp-tiers-h">' + (T.tTier || '') + '</p><ul>' + rows + '</ul><p class="sp-tiers-n">' + (T.tTierNote || '') + '</p>';
  }
};
